// ausgangslage — the opening prose page (v15 slide 2): two sans paragraphs at 22.7px / 1.62
// with Geist-Black emphasis, a hairline over the brand.
import type { AusgangslageContent } from '../../../../shared/deckTypes.js';
import { Abs, Brand, Dkp, Emph, Eyebrow, PageNo, Rule } from './chrome.js';

export default function AusgangslagePreview({ content, pageNo }: {
  content: AusgangslageContent;
  pageNo?: number | null;
}) {
  const c = content;
  const para = { fontSize: 22.7, fontWeight: 500, color: '#26282C', lineHeight: 1.62 } as const;
  return (
    <Dkp>
      <Eyebrow text={c.eyebrow ?? ''} />
      {c.paragraph1 ? (
        <Abs x={64} y={92.8} w={1060}><div style={para}><Emph text={c.paragraph1} /></div></Abs>
      ) : null}
      {c.paragraph2 ? (
        <Abs x={64} y={372} w={1060}><div style={para}><Emph text={c.paragraph2} /></div></Abs>
      ) : null}
      <Rule x={64} y={662} w={1152} />
      <Brand />
      <PageNo n={pageNo} />
    </Dkp>
  );
}
